import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { changeUserLastName, changeUserToLocalStorage } from '../../services/user.service';
import { toast } from 'react-toastify';
import { toggleModal } from '../../redux/modal.slicer';
import ModalComponents from '../modal/Modal.Components';

const UserChangeLastName = () => {
  const userStore = useSelector((state) => state.userStore.user); // Povlaci sacuvane podatke iz REDUX-a (folder redux)
  const [isLogged, setIsLogged] = useState(false);
  const [user, setUser] = useState(userStore);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (userStore) {
      setIsLogged(true);
    } else {
      navigate('/');
    }
  }, [navigate, userStore]);

  const handleChangeName = (e) => {
    let inputValue = e.target.value;
    let copyUser = { ...user, last_name: inputValue };
    setUser(copyUser);
  };

  const onChangeSubmit = (e) => {
    e.preventDefault();
    if (!user.last_name) {
      return toast.error('Polje ne sme biti prazno.');
    }
    if (user.last_name.length < 3 || user.last_name.length > 50) {
      return toast.error('Prezime mora imati od 3 do 50 karaktera');
    }
    changeUserLastName({ user_id: user.user_id, last_name: user.last_name })
      .then((res) => {
        toast.success(res.data);
        changeUserToLocalStorage(user);
        navigate(`/user/${user.user_id}`);
        dispatch(toggleModal(false));
        window.location.reload();
      })
      .catch((err) => {
        toast.error(err.response.data);
      });
  };

  return (
    <ModalComponents>
      {isLogged && (
        <div className="col-12 col-sm-6 m-auto my-3 text-start">
          <form onSubmit={onChangeSubmit}>
            <div className="mb-3">
              <label htmlFor="last_name" className="form-label">
                Promeni prezime:
              </label>
              <input
                type="text"
                className="form-control"
                id="last_name"
                aria-describedby="last_name"
                placeholder='Marković'
                defaultValue={userStore.last_name}
                onChange={(e) => handleChangeName(e)}
                minLength={3}
                maxLength={50}
              />
            </div>
            <button type="submit" className="btn btn-danger form-control">
              Izmeni
            </button>
          </form>
        </div>
      )}
    </ModalComponents>
  );
};

export default UserChangeLastName;
